import $ from 'jquery';

const $categoriesContainer = $('.js-categories-container');
const $categoriesToggle = $('.js-toggle-categories');
const $categoriesList = $('.js-categories-list');

$categoriesToggle.on('click', function(e) {
	$categoriesList.slideToggle();
	$categoriesContainer.toggleClass('is-open');
});